// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"Sidedrawer_SideDrawer__2G9Q6","Open":"Sidedrawer_Open__1sNZ3","Close":"Sidedrawer_Close__1GTI4"};